<template>
  <article
    class="sa-notifications-empty"
    role="status"
    aria-labelledby="dashboard-notifications-empty-title"
  >
    <div class="sa-notifications-empty__glow" aria-hidden="true" />
    <div class="sa-notifications-empty__glow sa-notifications-empty__glow--accent" aria-hidden="true" />

    <div class="sa-notifications-empty__inner">
      <header class="sa-notifications-empty__header">
        <div class="sa-notifications-empty__badge" aria-hidden="true">
          <svg viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M16.704 5.29a1 1 0 0 1 .006 1.414l-7.25 7.25a1 1 0 0 1-1.414 0l-3.25-3.25a1 1 0 1 1 1.414-1.414l2.543 2.543 6.543-6.543a1 1 0 0 1 1.414-.006Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="sa-notifications-empty__intro">
          <h3 id="dashboard-notifications-empty-title" class="sa-notifications-empty__title">
            {{ $t('Dashboard.Notifications.EmptyState.Title') }}
          </h3>
          <p class="sa-notifications-empty__lead">
            {{ $t('Dashboard.Notifications.EmptyState.Lead') }}
          </p>
        </div>
      </header>
    </div>
  </article>
</template>
